import { faClose, faAdd } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Input from 'components/common/form/input/Input';
import { FieldArray } from 'formik';
import React from 'react';
import { Skill } from './candidateSkillForm.type';
import Button from 'components/base/Button';

function CandidateSkillForm() {
  return (
    <FieldArray name="skills">
      {({ form: { values, errors }, remove, push }) => {
        return (
          <>
            <header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0 text-body-highlight">Skills</h5>
              <Button
                variant="link"
                startIcon={<FontAwesomeIcon icon={faAdd} className="me-2" />}
                onClick={() => push({ skill: '', experience: '' })}
              >
                Add Skill
              </Button>
            </header>
            <table className="my-4">
              <tr>
                <td width={200}>
                  <h5>Skill</h5>
                </td>
                <td width={200}>
                  <h5>Year of experience</h5>
                </td>
                <td width={50}></td>
              </tr>
              {errors && typeof errors.skills === 'string' && (
                <tr>
                  <td colSpan={3} className="invalid-feedback d-block">
                    {errors.skills}
                  </td>
                </tr>
              )}
              {values.skills.map((_: Skill, index: number) => {
                const skillName = `skills[${index}].skill`;
                const expName = `skills[${index}].experience`;
                return (
                  <tr key={index}>
                    <td className="pe-4 py-2">
                      <Input name={skillName} id={skillName} hideMessage />
                    </td>
                    <td className="pe-4 py-2">
                      <Input
                        name={expName}
                        id={expName}
                        type="number"
                        hideMessage
                      />
                    </td>
                    <td className="py-2">
                      <FontAwesomeIcon
                        icon={faClose}
                        onClick={() => remove(index)}
                      />
                    </td>
                  </tr>
                );
              })}
            </table>
          </>
        );
      }}
    </FieldArray>
  );
}

export default CandidateSkillForm;
